import Base from '../../company_admin/redemptions/index';

export default class extends Base {}
